const tasks = {
  notAvailable: 'No disponible',
  executing: 'Ejecutando',
  finished: 'Terminado',
  success: 'Éxito',
  any: 'Cualquiera',
  general: {
    search: 'Buscar por UUID',
    serialNmbr: 'Número de serie',
  },
  selectors: {
    selector4: {
      last7Days: 'Últimos 7 días',
      custom: 'Personalizado',
    },
  },
  table: {
    siteName: 'Nombre del sitio',
    date: 'Fecha',
    status: 'Estado',
    id: 'ID',
    id_detail: 'ID Detalle',
    serial_number: 'Número de serie',
    commandtype: 'Tipo de comando',
    entitytype: 'Tipo de entidad',
    started_at: 'Comenzó en',
    finished_at: 'Terminó en',
  },
  modal: {
    title: 'Tarea del controlador-Detalle',
    header: 'Encabezado',
  },
};

export default tasks;
